import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtMoney } from "@/components/erp";
import api from "@/lib/api";

const trT = (d) => (d ? d.slice(0, 10).split("-").reverse().join(".") : "");

// Fiyat kutusunun altında: bu ürünün tüm carilerdeki son satış/alış fiyatı; tıklayınca son 5 işlem, seçilen fiyat uygulanır
export const SonFiyat = ({ urunId, ad, tur = "satis", onSec, testid = "son-fiyat" }) => {
  const [l, setL] = useState(null);
  const [acik, setAcik] = useState(false);
  useEffect(() => {
    setL(null);
    if (!urunId && !(ad || "").trim()) return undefined;
    const t = setTimeout(() => api.get("/son-fiyatlar", { params: { tur, urun_id: urunId || "", ad: urunId ? "" : ad } }).then((r) => setL(r.data)).catch(() => setL([])), 350);
    return () => clearTimeout(t);
  }, [urunId, ad, tur]);
  if (!l) return null;
  const etiket = tur === "satis" ? "satış" : "alış";
  if (!l.length) return <div className="text-[10px] text-muted-foreground mt-0.5" data-testid={`${testid}-yok`}>Önceki {etiket} yok</div>;
  const s = l[0];
  return (
    <Popover open={acik} onOpenChange={setAcik}>
      <PopoverTrigger asChild>
        <button type="button" tabIndex={-1} data-testid={testid} className="mt-0.5 inline-flex items-center gap-1 text-[10px] text-sky-300 hover:underline text-left max-w-full">
          <History className="w-3 h-3 shrink-0" /><span className="truncate">Son {etiket}: {fmtMoney(s.fiyat, s.para_birimi)} · {s.cari} · {trT(s.tarih)}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="glass w-80 p-2" align="start" data-testid={`${testid}-liste`}>
        <div className="text-xs font-semibold px-1 pb-1">Son {l.length} {etiket}</div>
        {l.map((x, i) => (
          <button key={i} type="button" data-testid={`${testid}-sec-${i}`} onClick={() => { onSec?.(x.fiyat); setAcik(false); }} className="w-full flex items-center gap-2 px-1.5 py-1 rounded text-xs hover:bg-white/10 text-left">
            <span className="font-mono text-emerald-300 shrink-0">{fmtMoney(x.fiyat, x.para_birimi)}</span><span className="truncate flex-1">{x.cari}</span><span className="text-muted-foreground shrink-0">{x.belge} {x.no} · {trT(x.tarih)}</span>
          </button>))}
        {onSec && <div className="text-[10px] text-muted-foreground px-1 pt-1">Fiyatı uygulamak için bir satıra tıklayın.</div>}
      </PopoverContent>
    </Popover>
  );
};
